<template>
  <div class="boy_warphry">
    <div class="rkcz">
      <div>常住外来人口</div>
      <div class="twos">
        <div class="one">
          <span>{{ rows.czwlrk }}</span><span>(人)</span>
          <div>常住外来人口</div>
        </div>
        <!-- <div class="one aa">
          <span>31476</span><span>(人)</span>
          <div>男性人数</div>
        </div>
        <div class="one bb">
          <span>32434</span><span>(人)</span>
          <div>女性人口</div>
        </div> -->
      </div>
    </div>
    <!-- <el-card> -->
    <div class="npm">
      <p>分地区、户口登记地的常住外来人口</p>
      <div ref="echartsINof" class="echarts" style="height: 60vh"></div>
    </div>
    <!-- </el-card> -->
  </div>
</template>

<script>
import { tj,czrk } from "@/network";
export default {
  data() {
    return {
      name:"天津",
      rows:[]
    };
  },
  created() {},
  mounted() {
    this.getInfoList();
    this.getname(); 
    this.getInfoData();
    // this.handEchart();
  },
  methods: {
    getname() {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      myechart.on("legendselectchanged", (params)=> {
        // console.log(params.name)
        this.name = params.name;
        this.getInfoData();
      });
    },
    async getInfoList() {
      const { code, rows, total } = await czrk({villagesCode: "110105011"});
      this.rows = rows[0];
    },
    async getInfoData() {
      const { code, data, msg } = await tj({
        tableName: "jxq_fdqhkdjddczwlrk",
        streetCode: "110105011",
      });
      var compare = function (attribute) {
        return function (obj1, obj2) {
          var val1 = obj1[attribute];
          var val2 = obj2[attribute];
          // if (val1 < val2) {
          //   return 1;
          // } else if (val1 > val2) {
          //   return -1;
          // } else {
          //   return 0;
          // }
        };
      };
      if(this.name=="天津"){
        let datas = data.sort(compare("tianjin")); //通过Id排序完成后的数组
      }else if(this.name=="河北"){
        let datas = data.sort(compare("hebei")); //通过Id排序完成后的数组
      }else if(this.name=="山西"){
        let datas = data.sort(compare("shanxi")); //通过Id排序完成后的数组
      }else if(this.name=="内蒙古"){
        let datas = data.sort(compare("neimenggu")); //通过Id排序完成后的数组
      }else if(this.name=="辽宁"){
        let datas = data.sort(compare("liaoning")); //通过Id排序完成后的数组
      }else if(this.name=="吉林"){
        let datas = data.sort(compare("jilin")); //通过Id排序完成后的数组
      }else if(this.name=="黑龙江"){
        let datas = data.sort(compare("heilongjiang")); //通过Id排序完成后的数组
      }else if(this.name=="上海"){
        let datas = data.sort(compare("shanghai")); //通过Id排序完成后的数组
      }else if(this.name=="江苏"){
        let datas = data.sort(compare("jiangsu")); //通过Id排序完成后的数组
      }else if(this.name=="浙江"){
        let datas = data.sort(compare("zhejiang")); //通过Id排序完成后的数组
      }else if(this.name=="安徽"){
        let datas = data.sort(compare("anhui")); //通过Id排序完成后的数组
      }else if(this.name=="福建"){
        let datas = data.sort(compare("fujian")); //通过Id排序完成后的数组
      }else if(this.name=="江西"){
        let datas = data.sort(compare("jiangxi")); //通过Id排序完成后的数组
      }else if(this.name=="山东"){
        let datas = data.sort(compare("shandong")); //通过Id排序完成后的数组
      }else if(this.name=="河南"){
        let datas = data.sort(compare("henan")); //通过Id排序完成后的数组
      }else if(this.name=="湖北"){
        let datas = data.sort(compare("hubei")); //通过Id排序完成后的数组
      }else if(this.name=="湖南"){
        let datas = data.sort(compare("hunan")); //通过Id排序完成后的数组
      }else if(this.name=="广东"){
        let datas = data.sort(compare("guangdong")); //通过Id排序完成后的数组
      }else if(this.name=="广西"){
        let datas = data.sort(compare("guangxi")); //通过Id排序完成后的数组
      }else if(this.name=="海南"){
        let datas = data.sort(compare("hainan")); //通过Id排序完成后的数组
      }else if(this.name=="重庆"){
        let datas = data.sort(compare("chongqing")); //通过Id排序完成后的数组
      }else if(this.name=="四川"){
        let datas = data.sort(compare("sichuan")); //通过Id排序完成后的数组
      }else if(this.name=="贵州"){
        let datas = data.sort(compare("guizhou")); //通过Id排序完成后的数组
      }else if(this.name=="云南"){
        let datas = data.sort(compare("yunnan")); //通过Id排序完成后的数组
      }else if(this.name=="西藏"){
        let datas = data.sort(compare("xizang")); //通过Id排序完成后的数组
      }else if(this.name=="甘肃"){
        let datas = data.sort(compare("gansu")); //通过Id排序完成后的数组
      }else if(this.name=="青岛"){
        let datas = data.sort(compare("qingdao")); //通过Id排序完成后的数组
      }else if(this.name=="宁夏"){
        let datas = data.sort(compare("ningxia")); //通过Id排序完成后的数组
      }else if(this.name=="新疆"){
        let datas = data.sort(compare("xinjiang")); //通过Id排序完成后的数组
      }else{
        let datas = data.sort(compare("czwlrk")); //通过Id排序完成后的数组
      }
      // console.log(data, 456);
      // let czrk = [];
      let villages_name = [];
      let tianjin = [];
      let hebei = [];
      let shanxi = [];
      let neimenggu = [];
      let liaoning = [];
      let jilin = [];
      let heilongjiang = [];
      let shanghai = [];
      let jiangsu = [];
      let zhejiang = [];
      let anhui = [];
      let fujian = [];
      let jiangxi = [];
      let shandong = [];
      let henan = [];
      let hubei = [];
      let hunan = [];
      let guangdong = [];
      let guangxi = [];
      let hannan = [];
      let chongqing = [];
      let sichuan = [];
      let guizhou = [];
      let yunnan = [];
      let xizang = [];
      let gansu = [];
      let qinghai = [];
      let ningxia = [];
      let xinjiang = [];
      let czwlrk = [];
      for (const item of data) {
        // czrk.push(item.czrk);
        villages_name.push(item.villages_name);
        tianjin.push(item.tianjin);
        hebei.push(item.hebei);
        shanxi.push(item.shanxi);
        neimenggu.push(item.neimenggu);
        liaoning.push(item.liaoning);
        jilin.push(item.jilin);
        heilongjiang.push(item.heilongjiang);
        shanghai.push(item.shanghai);
        jiangsu.push(item.jiangsu);
        zhejiang.push(item.zhejiang);
        anhui.push(item.anhui);
        fujian.push(item.fujian);
        jiangxi.push(item.jiangxi);
        shandong.push(item.shandong);
        henan.push(item.henan);
        hubei.push(item.hubei);
        hunan.push(item.hunan);
        guangdong.push(item.guangdong);
        guangxi.push(item.guangxi);
        hannan.push(item.hannan);
        chongqing.push(item.chongqing);
        sichuan.push(item.sichuan);
        guizhou.push(item.guizhou);
        yunnan.push(item.yunnan);
        xizang.push(item.xizang);
        shanxi.push(item.shanxi);
        gansu.push(item.gansu);
        qinghai.push(item.qinghai);
        ningxia.push(item.ningxia);
        xinjiang.push(item.xinjiang);
      }
      this.handEchart(
        villages_name,
        tianjin,
        hebei,
        shanxi,
        neimenggu,
        liaoning,
        jilin,
        heilongjiang,
        shanghai,
        jiangsu,
        zhejiang,
        anhui,
        fujian,
        jiangxi,
        shandong,
        henan,
        hubei,
        hunan,
        guangdong,
        guangxi,
        hannan,
        chongqing,
        sichuan,
        guizhou,
        yunnan,
        xizang,
        gansu,
        qinghai,
        ningxia,
        xinjiang,
        czwlrk
      );
    },
    handEchart(
      es,
      tianjin,
      hebei,
      shanxi,
      neimenggu,
      liaoning,
      jilin,
      heilongjiang,
      shanghai,
      jiangsu,
      zhejiang,
      anhui,
      fujian,
      jiangxi,
      shandong,
      henan,
      hubei,
      hunan,
      guangdong,
      guangxi,
      hannan,
      chongqing,
      sichuan,
      guizhou,
      yunnan,
      xizang,
      gansu,
      qinghai,
      ningxia,
      xinjiang,
      czwlrk
    ) {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          selectedMode: "single", //取消图例的点击事件
          textStyle: {
            color: "#fff",
          },
          top: "0%"
        },
        textStyle: {
          color: "#fff",
        },
        grid: {
          left: "5%",
          right: "4%",
          bottom: "2%",
          top:"38%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: es,
            axisLabel: { interval: 0, rotate: 60 },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "天津",
            type: "bar",
            // barWidth: "50%",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: tianjin,
          },
          {
            name: "河北",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: hebei,
          },
          {
            name: "山西",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: shanxi,
          },
          {
            name: "内蒙古",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: neimenggu,
          },
          {
            name: "辽宁",
            type: "bar",
            stack: "Search Engine",
            data: liaoning,
            emphasis: {
              focus: "series",
            },
          },
          {
            name: "吉林",
            type: "bar",
            // barWidth: 5,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: jilin,
          },
          {
            name: "黑龙江",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: heilongjiang,
          },
          {
            name: "上海",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: shanghai,
          },
          {
            name: "江苏",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: jiangsu,
          },
          {
            name: "浙江",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: zhejiang,
          },
          {
            name: "安徽",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: anhui,
          },
          {
            name: "福建",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: fujian,
          },
          {
            name: "江西",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: jiangxi,
          },
          {
            name: "山东",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: shandong,
          },
          {
            name: "河南",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: henan,
          },
          {
            name: "湖北",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: hubei,
          },
          {
            name: "湖南",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: hunan,
          },
          {
            name: "广东",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: guangdong,
          },
          {
            name: "广西",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: guangxi,
          },
          {
            name: "海南",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: hannan,
          },
          {
            name: "重庆",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: chongqing,
          },
          {
            name: "四川",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: sichuan,
          },
          {
            name: "贵州",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: guizhou,
          },
          {
            name: "云南",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: yunnan,
          },
          {
            name: "西藏",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: xizang,
          },
          {
            name: "甘肃",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: gansu,
          },
          {
            name: "青海",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: qinghai,
          },
          {
            name: "宁夏",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: ningxia,
          },
          {
            name: "新疆",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: xinjiang,
          },
          // {
          //   name: "总计",
          //   type: "bar",
          //   stack: "Search Engine",
          //   emphasis: {
          //     focus: "series",
          //   },
          //   data: czwlrk,
          // },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.boy_warphry {
  background-color: rgba(20, 48, 99, 0);
  .npm {
    p {
      color: #fff;
      text-align: center;
      font-size: 18px;
      padding: 0.5vh;
    }
    .echarts {
      margin: 1vw;
    }
  }
}
.rkcz {
  div {
    color: #fff;
    text-align: center;
    margin-top: 1vh;
    font-size: 18px;
    margin-bottom:1vh;
  }
  .twos {
    border: 1px solid #21517d;
    margin: 0 2vw;
    margin-bottom: 0.8vw;
    .one {
      display: inline-block;
      font-size: 18px;
      color: #fffd7d;
      padding-top: 1vh;
      span:nth-child(2) {
        font-size: 12px;
      }
      div {
        font-size: 12px;
        color: #fff;
        margin-top: 5px;
      }
    }
    .aa {
      border-top: 0;
      border-bottom: 0;
      padding: 0 2.5vw;
    }
  }
}
</style>
